import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import combineReducers from "../reducers";

// Note: this API requires redux@>=3.1.0
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  combineReducers,
  composeEnhancers(applyMiddleware(thunk))
);
// export const store = createStore(combineReducers, applyMiddleware(thunk));
// export const store = createStore(rootReducer);
